// ** Initial State
const initialState = {
  dropdown: [],
  dropdownFormatted: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedDepartment: null
}

const departments = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DEPARTMENTS_DROPDOWN':
      return { 
        ...state, 
        dropdown: action.data,
        dropdownFormatted: action.data.map(item => ({
          label: item.department,
          value: item.id,
        }))
       }
    case 'GET_ALL_DEPARTMENTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_DEPARTMENTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_DEPARTMENT':
      return { ...state, selectedDepartment: action.selectedDepartment }
    case 'ADD_DEPARTMENT':
      return { ...state }
    case 'DELETE_DEPARTMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default departments
